import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";
import About from "./Pages/About";
import Products from "./Pages/Products";
import Clientele from "./Pages/Clientele";
import Contact from "./Pages/Contact";
import Footer from "./components/Footer";
import SpeedDialComponent from "./components/SpeedDialComponent";
import Careers from "./Pages/Careers";
import Form from "./components/Form";
import EdVedhaPage from "./Pages/EdVedhaPage";
import UNICodePage from "./Pages/UNICodePage";
import ICampusBEAT from "./Pages/ICampusBEAT";
import ICampusBOAT from "./Pages/ICampusBOAT";
import Privacypolicy from "./Pages/Privacypolicy";
import TermsandConditions from "./Pages/TermsandConditions";
import NotFound from "./Pages/NotFound";

function App() {
  return (
    <React.Fragment>
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/clientele" element={<Clientele />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/form" element={<Form />} />
        <Route path="/edvedha" element={<EdVedhaPage />} />
        <Route path="/unicode" element={<UNICodePage />} />
        <Route path="/icampusbeat" element={<ICampusBEAT />} />
        <Route path="/icampus-boat" element={<ICampusBOAT />} />
        <Route path="/privacy-policy" element={<Privacypolicy />} />
        <Route path="/terms-and-conditions" element={<TermsandConditions />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <SpeedDialComponent />
    </React.Fragment>
  );
}

export default App;

